export default __webpack_public_path__ + "static/media/kw.75152e7e.svg";